import { TenantCategory } from './const/enums';
import { ContactIdKind } from './contact';

export class IdType {
  constructor(category: TenantCategory, idType: ContactIdKind) {
    this.category = category;
    this.idType = idType;
    this.caption = 'TENANT.ID_TYPE.T' + idType.toString();
  }

  idType: ContactIdKind;
  category: TenantCategory;
  caption: string;
}
